/* eslint-disable indent */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import { useTranslation } from 'react-i18next';
import { FormCheckbox } from 'components/Form';
import { API_WP_CONTENT_URL } from 'utils/api';
import classNames from 'classnames';

const TermsBlock = ({ isTermsChecked, isTermsCheckedMissing, setIsTermsChecked }) => {
	const { t } = useTranslation('cartPage');
	const termsLink = t('homePage:termsAndConditionsLinkFmt').replace('{}', API_WP_CONTENT_URL);
	const disclaimerLink = t('homePage:disclaimerLinkFmt').replace('{}', API_WP_CONTENT_URL);
	const termsText = t('termsText')
		.replace('{termsURL}', termsLink)
		.replace('{disclaimerURL}', disclaimerLink);
	const classes = classNames('terms_block', { 'terms_block--missing': isTermsCheckedMissing });

	return (
		<div className={classes}>
			<FormCheckbox
				title={`${termsText}`}
				name="terms"
				checked={isTermsChecked}
				onChange={() => setIsTermsChecked(prev => !prev)}
			/>
		</div>
	);
};

export default TermsBlock;
